(() => {
  const COUNTRY = (window.__SHOPIFY_VISITOR_COUNTRY__ || "").toUpperCase();
  const IS_US = COUNTRY === "US";

  // Likely UpCart host element. We'll try a few.
  const HOST_SELECTORS = [
    "#UpcartPopup",
    "upcart-popup",
    "[id*='Upcart']",
    "[id*='upcart']"
  ];

  const TARGET_SELECTOR = ".upcart-rewards";

  function applyInShadow(host) {
    if (!host || !host.shadowRoot) return false;

    const targets = host.shadowRoot.querySelectorAll(TARGET_SELECTOR);
    if (!targets.length) return false;

    targets.forEach(el => {
      el.style.setProperty("display", IS_US ? "" : "none", "important");
    });

    return true;
  }

  function findHosts() {
    const hosts = [];
    for (const sel of HOST_SELECTORS) {
      document.querySelectorAll(sel).forEach(el => hosts.push(el));
    }
    // Also include any element with an open shadowRoot
    document.querySelectorAll("*").forEach(el => {
      if (el.shadowRoot) hosts.push(el);
    });
    return hosts;
  }

  function applyEverywhere() {
    const hosts = findHosts();
    let changed = false;
    for (const h of hosts) {
      changed = applyInShadow(h) || changed;
    }
    return changed;
  }

  // Run now
  applyEverywhere();

  // Observe DOM changes (UpCart re-renders)
  const obs = new MutationObserver(() => applyEverywhere());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Also poll briefly to catch late-mounted shadow DOM
  const start = Date.now();
  const t = setInterval(() => {
    const ok = applyEverywhere();
    if (ok || Date.now() - start > 8000) clearInterval(t);
  }, 200);
})();
